import { useAdminApiClient } from '@api/clients'
import { useMutation } from '@tanstack/react-query'

export const useGetAccountByEmail = () => {
  const client = useAdminApiClient()
  return useMutation({
    mutationFn: (data: any) => {
      return client(`projects/${data.projectId}/accounts/${data.authId}`, {
        method: 'get',
      })
    },
  })
}
